<template>
    <div>
        <epi-link :url="url"
                  :title="text"
                  :className="`justify-center btn btn-green btn-${size} m-auto`">
            {{ text }}
        </epi-link>
        <div v-show="inEditMode">
            <EpiProperty propertyName="Size" />
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import EpiProperty from '@/Scripts/components/EpiProperty.vue';
import { mapState } from 'vuex';

export default {
    props: {
        model: Object,
        text: String,
        url: String,
        size: {
            type: String,
            'default': 'm'
        }
    },
    components: {
        EpiLink,
        EpiProperty
    },
    computed: mapState({
        inEditMode: state => state.epiContext.inEditMode
    }),
    methods: {
        log(obj) {
            console.log(obj);
        }
    }
};
</script>


